import Vue from 'vue'
import * as types from './mutation-types.js'

const actions = {
  subscribeToAudioTranscode ({ commit }, {type, eventId}) {
    const message = {
      type: type,
      subscribe: eventId
    }
    commit(types.SET_EVENT, {type, eventId})
    Vue.prototype.$socket.sendObj(message)
  },
  unsubscribeToAudioTranscode ({ commit }, {type, eventId}) {
    const message = {
      type: type,
      unsubscribe: eventId
    }
    Vue.prototype.$socket.sendObj(message)
    commit(types.CLEAR_EVENT)
  }
}

export default actions
